import { classNames } from '../utilities';

export const InfoIcon = ({ className, onClick }) => {
  return (
    <svg
      className={classNames('', className ? className : '')}
      onClick={onClick ? onClick : () => null}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.28949 13.5H9.7105V8.05263H8.28949V13.5ZM9 6.43118C9.21681 6.43118 9.39853 6.35785 9.54519 6.2112C9.69184 6.06455 9.76517 5.88282 9.76517 5.66601C9.76517 5.44922 9.69184 5.26749 9.54519 5.12082C9.39853 4.97417 9.21681 4.90084 9 4.90084C8.78319 4.90084 8.60146 4.97417 8.45481 5.12082C8.30816 5.26749 8.23483 5.44922 8.23483 5.66601C8.23483 5.88282 8.30816 6.06455 8.45481 6.2112C8.60146 6.35785 8.78319 6.43118 9 6.43118ZM9.00159 18C7.7568 18 6.58677 17.7638 5.49148 17.2914C4.39618 16.8189 3.44342 16.1778 2.63322 15.368C1.82299 14.5581 1.18157 13.6058 0.708941 12.511C0.236314 11.4162 0 10.2464 0 9.00159C0 7.7568 0.236211 6.58677 0.708634 5.49148C1.18106 4.39618 1.82219 3.44343 2.63203 2.63322C3.44189 1.823 4.39423 1.18157 5.48904 0.708942C6.58384 0.236315 7.75363 0 8.99841 0C10.2432 0 11.4132 0.236212 12.5085 0.708634C13.6038 1.18106 14.5566 1.82219 15.3668 2.63203C16.177 3.44189 16.8184 4.39423 17.2911 5.48904C17.7637 6.58384 18 7.75363 18 8.99841C18 10.2432 17.7638 11.4132 17.2914 12.5085C16.8189 13.6038 16.1778 14.5566 15.368 15.3668C14.5581 16.177 13.6058 16.8184 12.511 17.2911C11.4162 17.7637 10.2464 18 9.00159 18Z"
        fill="#1777FF"
      />
    </svg>
  );
};
